<template>
  <div class="schedule container">
    <h1>Opportunities</h1>
    <div class="">
      <div class="schedule-col" v-for="(day, dayNum) in presentations" :key="(day, dayNum)">
        <div class="schedule-col-contents">
          <h2 class="schedule-col-header">Day {{ dayNum + 1 }}</h2>
          <div v-for="presentation in filterDay(day)" :key="presentation.title">
            <div v-if="presentation.recommendations" class="schedule-col-section">
              <h3 class="presentation-speaker">{{ speakerNames(presentation.speakers) }}</h3>
              <p>
                <span class="presentation-subheader">Presentation:</span>
                <span class="presentation-link">
                  <router-link :to="presentationLink(presentation, dayNum + 1)">
                    <span v-html="presentation.title"></span>
                  </router-link>
                </span>
              </p>
              <p>
                <span class="presentation-subheader">Opportunities:</span>
                <span class="presentation-recommendation">{{ recommendationNames(presentation.recommendations) }}</span>
              </p>
            </div>
            <div v-else-if="presentation === 'none'" class="schedule-col-section">
              <h3 class="presentation-speaker">No recommendations have been posted yet.</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';

export default {
  name: 'Recommendations',
  firebase: helpers.getFirebaseObject(db),
  beforeMount() {
    auth.requireLogin();
  },
  computed: {
    presentations() {
      // console.log(helpers.getPresentationsByDay(this.speakers))
      return helpers.getPresentationsByDay(this.speakers, this.options);
    },
  },
  methods: {
    filterDay(day) {
      day = day.filter(presentation => presentation.recommendations !== undefined);
      if(day.length === 0)
      {
        return ["none"];
      }
      return day;
    },
    speakerNames(speakers) {
      let rtn = '';
      speakers.forEach((speaker, i) => {
        if (speakers.length > 1 && i === speakers.length - 1) {
          rtn += 'and ';
        }
        rtn += speaker;
        if (i !== speakers.length - 1) {
          rtn += ', ';
        }
      });
      return rtn;
    },
    presentationLink(presentation, dayNum) {
      let hashCode = helpers.getPresentationHash(presentation);
      return '/archive/'+dayNum+'/'+hashCode;
    },
    recommendationNames(recommendations) {
      let rtn = '';

      recommendations.forEach((recommendation, i) => {
        if (recommendations.length > 1 && i === recommendations.length - 1) {
          rtn += 'and ';
        }
        rtn += recommendation;
        if (i !== recommendations.length - 1) {
          rtn += ', ';
        }
      });
      return rtn;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.schedule-col {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Recommendations.vue